import React, { useState, useRef } from 'react';
import {
  Box,
  TextField,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  Send as SendIcon,
  AttachFile as AttachIcon,
  EmojiEmotions as EmojiIcon
} from '@mui/icons-material';

const MessageInput = ({ onSend, onUpload, disabled }) => {
  const [input, setInput] = useState('');
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleSend = async () => {
    if (!input.trim()) return;
    try {
      await onSend(input);
      setInput('');
    } catch (err) {
      console.error('Failed to send:', err);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      await onUpload(file);
    } catch (err) {
      alert('Upload failed: ' + err.message);
    } finally {
      setUploading(false);
      e.target.value = ''; // Reset input
    }
  };

  return (
    <Box className="message-input-container">
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
      />

      <Tooltip title="Add attachment">
        <IconButton 
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled || uploading}
          className="attach-btn"
        >
          <AttachIcon />
        </IconButton>
      </Tooltip>

      <TextField
        fullWidth
        multiline
        maxRows={4}
        placeholder={uploading ? "Uploading..." : "Type a message..."}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyPress={handleKeyPress}
        disabled={disabled || uploading}
        className="message-input"
        variant="outlined"
        size="small"
      />

      <Tooltip title="Send message">
        <span>
          <IconButton 
            onClick={handleSend}
            disabled={!input.trim() || disabled || uploading}
            className="send-btn"
            color="primary"
          >
            <SendIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default MessageInput;